import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


function Brsr() {
  const pageid = 7; // <-- set correct pageid from backend
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBrsrReports = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setReports([]);
          setLoading(false);
          return;
        }

        // Map only pdf_name + upload_file_path
        const mapped = result.data.map((item) => ({
          label: item.pdf_name,          // shown as link text
          file: item.upload_file_path,   // used for href
        }));

        setReports(mapped);
      } catch (error) {
        console.error("Fetch failed:", error);
        setReports([]);
      } finally {
        setLoading(false);
      }
    };

    fetchBrsrReports();
  }, []);

  return (
    <>
      <Helmet>
        <title>BRSR | Nandan Denim Ltd.</title>
      </Helmet>

      <Header />
      <div>
        {/* Hero Section */}
        <div className="relative w-full">
          <img
            src="./imgs/investors/investorbrsr.png"
            alt="Chiripal Group Banner"
            className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
          />
          <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center">
            <div className="px-4 sm:px-8 md:px-16 lg:px-32">
              <h1 className="text-white text-3xl sm:text-5xl md:text-7xl font-bold font-montserrat text-left">
                BRSR
              </h1>
            </div>
          </div>
        </div>

        {/* PDF Section */}
        <div className="py-12 px-4 sm:px-8 md:px-16 lg:px-24 font-signika max-w-7xl mx-auto">
          {loading ? (
            <p>Loading BRSR reports...</p>
          ) : reports.length === 0 ? (
            <p>No BRSR reports found.</p>
          ) : (
            <ul className="list-disc pl-6 space-y-2 text-[#0b3a6a]">
              {reports.map((report, idx) => (
                <li key={idx}>
                  <a
                    href={`${API_PDF_URL}/${report.file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    {report.label}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Brsr;
